import { FullscreenCentered, NotFoundIcon } from '@diana/core';
import { Button, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ERROR_PAGES_NS } from './i18n';

export const NotFound = () => {
  const { t } = useTranslation(ERROR_PAGES_NS);
  const { breakpoints } = useTheme();
  const isTabletOrMobile = useMediaQuery(breakpoints.down('md'));

  return (
    <FullscreenCentered>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={1}
        width={isTabletOrMobile ? '100%' : '534px'}
      >
        <NotFoundIcon />
        <Typography variant="h4" sx={{ textAlign: 'center' }}>
          {t('pageNotFound')}
        </Typography>
        <Typography variant="h4" sx={{ textAlign: 'center' }}>
          {t('pageDoesntExist')}
        </Typography>
        <Button variant="contained" sx={{ marginTop: '16px!important' }}>
          {t('goBack')}
        </Button>
      </Stack>
    </FullscreenCentered>
  );
};

export const Component = NotFound;
